// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kartana: PokeData = {
  "id": 798,
  "name": "kartana",
  "height": 3,
  "weight": 1,
  "base_experience": 257,
  "types": [
    PokeType.GRASS,
    PokeType.STEEL
  ],
  "api_moves": [
    "guillotine",
    "swords-dance",
    "cut",
    "razor-leaf",
    "detect",
    "false-swipe",
    "fury-cutter",
    "synthesis",
    "air-cutter",
    "aerial-ace",
    "leaf-blade",
    "night-slash",
    "air-slash",
    "x-scissor",
    "vacuum-wave",
    "psycho-cut",
    "defog",
    "sacred-sword",
    "laser-focus"
  ],
  "moves": [
    "razor-leaf",
    "synthesis",
    "aerial-ace",
    "night-slash",
    "air-slash",
    "vacuum-wave",
    "solar-beam",
    "grassy-terrain",
    "power-whip",
    "branch-poke",
    "leaf-tornado",
    "vine-whip",
    "metal-claw"
  ],
  "evolution_chain": {
    "id": 419,
    "item": null,
    "species": [
      {
        "name": "kartana",
        "order": 798,
        "types": [
          PokeType.GRASS,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 78,
    "speed": 121,
    "ability_power": 201
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
